module.exports = __webpack_public_path__ + "img/user_logo.f2c4aa08.png";